import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 我的关注
export function getattention(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/attention',
    method: 'get',
    params
  })
}
// 列表数据
export function getDataList(data) {
  return axios.request({
    // url: urlObj.wss + 'wss-part/parts/listPart',
    url: urlObj.wss + 'wss-part/parts/search/world',
    // url:
    //   'https://www.fastmock.site/mock/cdb00a63b70f9a6932a0fa8972a99235/wss-front/getSupportselfList',
    method: 'post',
    data
  })
}
// 获取配件类型列表
export function getListPartsType() {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listPartsType',
    method: 'get'
  })
}
// 询价确认
export function getenquiryqd(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/enquiry/createEnquiryOrder',
    method: 'post',
    data
  })
}
// 加购
export function saveOrUpdate(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/saveShoppingCart',
    // url: urlObj.zxy + 'wss-order/shopping/saveShoppingCart',
    method: 'post',
    data
  })
}
// 联盟
export function getLeagueForTenant(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenantLeague/getGdLeagueForTenant',
    method: 'get',
    params
  })
}
// // 获取收货地址
// 需求变更 这个接口暂时不用
// export function getListAddress(params) {
//   return axios.request({
//     url: urlObj.wss + 'wss-order/address/listAddress',
//     method: 'get',
//     params
//   })
// }
export function getListAddress(params) {
  return axios.request({
    url: urlObj.crm + 'crm/resarea/gateway/city/inventory',
    method: 'get',
    params
  })
}
// 获取门店
export function getShopByTenantIds() {
  return axios.request({
    url: urlObj.crm + 'crm/shop/getShopByTenantIds',
    method: 'get'
  })
}
// 获取适用配件
export function getCarModelOeCodes(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getCarModelOeCodes',
    method: 'get',
    params
  })
}
// 立即购买
export function prebuy(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/parts/prebuy',
    // url: urlObj.zxy + 'wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}

// 获取仓库
export function getWare(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/store/tenant',
    // url: urlObj.zxy + 'wss-order/orders/parts/prebuy',
    method: 'get',
    params
  })
}

// 获取联盟列表数据
export function getDataListworld(data) {
  return axios.request({
    // url: urlObj.wss + 'wss-part/parts/listPart',
    url: urlObj.wss + 'wss-part/parts/search/world',
    // url:
    //   'https://www.fastmock.site/mock/cdb00a63b70f9a6932a0fa8972a99235/wss-front/getSupportselfList',
    method: 'post',
    data
  })
}
